import { useEffect, useState } from 'react';
import cn from 'classnames';
import { useAnimation, motion } from 'framer-motion';
import Icons from '../Icons';
import Participants from '../Participants';
import './RoomFooterMobile.scss';

interface RoomFooterMobileProps {
  isDocumentPIP?: boolean; // Optional since we have a default
}

const RoomFooterMobile = ({ isDocumentPIP = false }: RoomFooterMobileProps) => {
  const controls = useAnimation();
  const H = window.innerHeight;
  const sheetHeight = H - 60;
  const collapsedY = sheetHeight - 112;
  const expandedY = 0;
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    controls.set({ y: collapsedY });
  }, [collapsedY, controls]);

  const handleDragStart = (event: MouseEvent | TouchEvent, info: any) => {
    setIsExpanded(true);
  };

  const handleDragEnd = async (event: MouseEvent | TouchEvent, info: any) => {
    const threshold = (collapsedY - expandedY) / 2;

    const participantsRow = (event.target as HTMLElement).closest('#participants-mobile') as HTMLElement;

    if (participantsRow) {
      event.preventDefault();
      controls.stop();
      return;
    }

    if (info.offset.y < -threshold) {
      await controls.start({ y: expandedY, transition: { duration: 0.3, ease: 'easeOut' } });
      setIsExpanded(true);
    } else {
      await controls.start({ y: collapsedY, transition: { duration: 0.3, ease: 'easeOut' } });
      setIsExpanded(false);
    }
  };

  const hideSheet = async () => {
    await controls.start({ y: collapsedY, transition: { duration: 0.3, ease: 'easeOut' } });
    setIsExpanded(false);
  };

  const content = (
    <>
      <Icons isExpanded={isExpanded} onHideSheet={hideSheet} isDocumentPIP={isDocumentPIP} />
      {isExpanded && <Participants onHideSheet={hideSheet} />}
    </>
  );

  return (
    <>
      {isDocumentPIP && (
        <div className={'footer-Mobile footer-pip w-full flex flex-col items-center justify-content-end gap-3'}>
          {content}
        </div>
      )}

      {!isDocumentPIP && (
        <motion.div
          className={cn('footer-Mobile w-full flex flex-col items-center gap-3', {
            isExpanded: isExpanded && !isDocumentPIP,
          })}
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 999,
            height: sheetHeight,
            padding: '16px 20px 0',
          }}
          drag={'y'}
          dragConstraints={{ top: expandedY, bottom: collapsedY }}
          dragElastic={0.2}
          animate={controls}
          onDragEnd={handleDragEnd}
          onDragStart={handleDragStart}
        >
          <div className="footer-Mobile__expand" id="footer-Mobile__expand" />
          {content}
        </motion.div>
      )}
    </>
  );
};

export default RoomFooterMobile;
